// src/api/companyApi.ts

import { ENV } from '../../config/runtimeEnv';

// Types
import { Company } from "../../types/admin/CompanyTypes";
import { http } from "../../lib/http/client";


const API_BASE_URL = ENV.VITE_HEALTHCARE_SERVER;


export const fetchCompanies = async (
	page: number,
	perPage: number,
	search?: string,
): Promise<{
	data: Company[];
	total: number;
}> => {
	try {
		const response = await http.get(`${API_BASE_URL}/admin/companies`, {
			params: {
				page,
				per_page: perPage,
				...(search ? { search } : {}),

			},
		});

		return {
			data: response.data.data,
			total: response.data.pagination.total_items,
		};
	} catch (error) {
		console.error('Error fetching companies:', error);
		throw error;
	}
};

// One company per clinic DB — resolve the single clinic company (no name filtering).
export const fetchClinicCompany = async (): Promise<Company> => {
	const response = await http.get(`${API_BASE_URL}/admin/companies`, {
		params: { page: 1, per_page: 1 },
	});
	return response.data.data[0];
}

export const updateCompany = async (
    id: number,
    updatedData: Company
): Promise<{message: string , data : Company}> => {
    try {
        const response = await http.put(`${API_BASE_URL}/admin/companies/${id}`, updatedData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response.data;
    } catch (error: any) {
        // Handle errors appropriately
        console.error('Error updating company:', error);
        // Optionally, extract and throw a more specific error message
        if (error.response && error.response.data) {
            throw new Error(error.response.data.message || 'Failed to update company.');
        } else {
            throw new Error('Failed to update company.');
        }
    }
};